import { render, staticRenderFns } from "./WidgetInstance.vue?vue&type=template&id=6a800694&"
import script from "./WidgetInstance.vue?vue&type=script&lang=js&"
export * from "./WidgetInstance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports